import { theme } from "../../theme.js";

export default function ChartCard({ children }) {
  return (
    <div style={styles.chartCard}>
      {children}      
    </div>
  );
}

const styles = {
  chartCard: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.md,
    padding: theme.spacing.lg,
    width: "fit-content",
    height: "fit-content",
  }
};